import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, Button, Box, Typography } from '@mui/material';
import { FiAlertTriangle } from 'react-icons/fi';
import { commonStyles as style } from 'assets/style';

const ConfirmationActionDialog = ({ open, onConfirm, onClose, message, confirmText, cancelText, maxWidth, blurBackdrop, confirmDisabled, cancelDisabled }) => {
    const renderMessage = () => {
        if (typeof message === 'string') {
            return (
                <Typography variant="h5" id="confirmation-dialog-description" mt={2} sx={{ fontWeight: 'bold' }}>
                    {message}
                </Typography>
            );
        }
        return message;
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-describedby="confirmation-dialog-description"
            slotProps={blurBackdrop ? { backdrop: { sx: { backdropFilter: 'blur(6px)' } } } : undefined}
        >
            <DialogContent
                sx={{
                    maxWidth,
                    textAlign: 'center',
                    border: (theme) => `10px solid ${theme.palette.border.$color_border_default}`,
                }}
            >
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                    <FiAlertTriangle color="#d02424" size={70} />
                    {renderMessage()}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={style.modalSaveButton}
                        onClick={onConfirm}
                        disabled={confirmDisabled}
                        data-testid="confirmYes"
                        className="uppercase tracking-wider text-sm"
                    >
                        {confirmText}
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{ ...style.modalCancelButton, ml: '10px' }}
                        onClick={onClose}
                        disabled={cancelDisabled}
                        data-testid="confirmNo"
                        className="uppercase tracking-wider text-sm"
                    >
                        {cancelText}
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

ConfirmationActionDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    message: PropTypes.node,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    maxWidth: PropTypes.string,
    blurBackdrop: PropTypes.bool,
    confirmDisabled: PropTypes.bool,
    cancelDisabled: PropTypes.bool,
};

ConfirmationActionDialog.defaultProps = {
    message: 'Are you sure you want to leave without saving changes?',
    confirmText: 'Yes',
    cancelText: 'No',
    maxWidth: '440px',
    blurBackdrop: false,
    confirmDisabled: false,
    cancelDisabled: false,
};

export default ConfirmationActionDialog;
